import { Link } from "react-router-dom";
import { useT } from "@/contexts/I18nContext";
import type { Alert } from "@/services/alerts";

/**
 * The alerts.
 *
 * **Nothing at all when there is nothing to say.** A widget that is present and
 * empty every day teaches people to stop looking at that part of the screen,
 * and the one morning it is not empty is the morning nobody notices. An absent
 * strip and a full one are different shapes, and that is what makes the full
 * one catch an eye.
 */
export function AlertsStrip({ alerts }: { alerts: readonly Alert[] }) {
  const t = useT();
  if (alerts.length === 0) return null;

  return (
    <ul role="alert" className="mb-8 flex flex-col gap-2">
      {alerts.map((alert) => (
        <li
          key={alert.kind}
          className={`flex flex-wrap items-center justify-between gap-4 rounded-md border px-5 py-3 ${
            alert.kind === "aiBoundaryViolation"
              ? "border-accent bg-accent-soft"
              : "border-cue-amber bg-cue-amber-soft"
          }`}
        >
          <span className="text-sm text-ink">{t(alert.messageKey, alert.params)}</span>
          <Link
            to={alert.href}
            className="text-sm font-medium text-ink underline underline-offset-2"
          >
            {t("common.edit")}
          </Link>
        </li>
      ))}
    </ul>
  );
}
